import React, { useMemo } from "react";
import { Container, Row, Col } from "react-bootstrap";
import SocialLinks from "./SocialLinks";

function Footer() {
  const year = useMemo(() => new Date().getFullYear(), []);

  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>Designed and Developed by Dheeraj Jain</h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>Copyright © {year} DJ</h3>
        </Col>
        <Col md="4" className="footer-body">
          <SocialLinks
            className="footer-icons"
            iconClassName="footer-social-icon"
          />
        </Col>
      </Row>
    </Container>
  );
}

export default React.memo(Footer);
